import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import { Coach }            from "Utils/API";
import MediaType            from "dashboard/dist/Core/MediaType";
import Status               from "dashboard/dist/Core/Status";
import Utils                from "dashboard/dist/Utils/Utils";

// Components
import MediaField           from "Components/Utils/Media/MediaField";
import EditDialog           from "dashboard/dist/Components/EditDialog";
import Columns              from "dashboard/dist/Components/Columns";
import InputField           from "dashboard/dist/Components/InputField";

// Actions
import {
    fetchStaff, fetchStaffCreate, editStaff,
} from "Actions/Admin/Setup/StaffActions";



/**
 * The Staff Edit Dialog
 */
class StaffEdit extends React.Component {
    // The Initial Data
    initialData = {
        staffID        : 0,
        name           : "",
        credentialID   : 0,
        credentialName : "",
        summary        : "",
        biography      : "",
        image          : "",
        position       : "",
        status         : Status.getID("ACTIVE"),
    }

    // The Current State
    state = {
        loading : false,
        data    : { ...this.initialData },
        errors  : {},
    }



    /**
     * Get the Data when the Element ID changes
     * @param {Object} prevProps
     * @returns {Void}
     */
    componentDidUpdate(prevProps) {
        const { open, edition, elemID, elem, position, fetchStaff, fetchStaffCreate } = this.props;
        let loading = false;
        let data    = null;

        // Dialog Opens
        if (open && !prevProps.open) {
            data = { ...this.initialData };
            // Load new data
            if (elemID) {
                fetchStaff(elemID);
                loading = true;
            // Load edit data
            } else {
                fetchStaffCreate();
                loading = true;
            }

        // Data Updated
        } else if (prevProps.edition !== edition) {
            if (elemID) {
                data = Utils.extend(this.initialData, elem);
            } else {
                data = { ...this.initialData, position };
            }
        }

        // Set the State
        if (data) {
            this.setState({ data, loading, errors : {} });
        }
    }

    /**
     * Handles the Input Change
     * @param {String} name
     * @param {*}      value
     * @returns {Void}
     */
    handleChange = (name, value) => {
        this.setState({
            data   : { ...this.state.data,   [name] : value },
            errors : { ...this.state.errors, [name] : ""    },
        });
    }

    /**
     * Handles the Submit
     * @returns {Promise}
     */
    handleSubmit = async () => {
        const { data, loading } = this.state;
        if (!loading) {
            this.setState({ loading : true, errors : {} });
            try {
                await this.props.editStaff(data);
                this.setState({ loading : false });
                this.props.onSubmit();
            } catch (errors) {
                this.setState({ loading : false, errors });
            }
        }
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { elemID, open, onClose } = this.props;
        const { data, loading, errors } = this.state;

        return <EditDialog
            open={open}
            icon="staff"
            title={!!elemID ? "STAFF_EDIT_TITLE" : "STAFF_CREATE_TITLE"}
            error={errors.form}
            onSubmit={this.handleSubmit}
            onClose={onClose}
            isLoading={loading}
        >
            <InputField
                name="name"
                label="STAFF_ITS_NAME"
                value={data.name}
                error={errors.name}
                onChange={this.handleChange}
                isRequired
            />
            <InputField
                name="credentialName"
                label="STAFF_COACH"
                suggestID="credentialID"
                suggestFetch={Coach.search}
                suggestNone="COACHES_NONE_AVAILABLE"
                value={data.credentialName}
                onChange={this.handleChange}
            />
            <InputField
                name="summary"
                label="STAFF_SUMMARY"
                value={data.summary}
                error={errors.summary}
                onChange={this.handleChange}
            />
            <InputField
                type="textarea"
                name="biography"
                label="STAFF_ITS_BIOGRAPHY"
                value={data.biography}
                error={errors.biography}
                onChange={this.handleChange}
            />
            <MediaField
                name="image"
                label="STAFF_IMAGE"
                mesdiaType={MediaType.IMAGE}
                mediaPath="sitio"
                value={data.image}
                error={errors.image}
                onChange={this.handleChange}
                isRequired
            />
            <Columns>
                <InputField
                    type="number"
                    name="position"
                    label="GENERAL_POSITION"
                    value={data.position}
                    error={errors.position}
                    onChange={this.handleChange}
                    shrinkLabel
                />
                <InputField
                    type="select"
                    name="status"
                    label="GENERAL_STATUS"
                    value={data.status}
                    error={errors.status}
                    onChange={this.handleChange}
                    options={Status.getSelect()}
                    withNone
                    isRequired
                    shrinkLabel
                />
            </Columns>
        </EditDialog>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchStaff       : PropTypes.func.isRequired,
        fetchStaffCreate : PropTypes.func.isRequired,
        editStaff        : PropTypes.func.isRequired,
        open             : PropTypes.bool.isRequired,
        onClose          : PropTypes.func.isRequired,
        onSubmit         : PropTypes.func.isRequired,
        edition          : PropTypes.number.isRequired,
        position         : PropTypes.number.isRequired,
        elem             : PropTypes.object.isRequired,
        elemID           : PropTypes.number,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            edition  : state.staff.edition,
            position : state.staff.position,
            elem     : state.staff.elem,
        };
    }
}

export default connect(StaffEdit.mapStateToProps, {
    fetchStaff, fetchStaffCreate, editStaff,
})(StaffEdit);
